











import { Component, Mixins } from 'vue-property-decorator';
import { View } from 'client-website-ts-library/plugins';
import { API, Config } from 'client-website-ts-library/services';
import { ProfileFilter } from 'client-website-ts-library/filters';
import { Office, Profile, WebsiteLevel, WebsiteProfileDisplayType } from 'client-website-ts-library/types';
import ProfileCards from '@/components/ProfileCards.vue';
import Loader from '@/components/UI/Loader.vue';

import NavigationLink from '../components/Common/NavigationLink.vue';
import Button from '../components/UI/Button.vue';

@Component({
  components: {
    NavigationLink,
    Button,
    ProfileCards,
    Loader,
  },
})
export default class About extends Mixins(View) {
  public profiles: Profile[] = [];

  private office: Office | null = null;

  mounted() {
    API.Offices.Get(Config.Website.Settings!.WebsiteId).then((office) => {
      this.office = office;
    });
  }
}
